import { UserModule } from "@/store/modules/user";
import { isJiHE, isWechat, setLastUserRoute } from ".";
import router from "@/router";
import Cookies from "js-cookie";

export function getToken() {
  if (isJiHE()) {
    return Cookies.get("token") || "";
  }

  // 如果存在token过期时间，校验时间
  if (getTokenTimeout()) {
    // token过期，清除登录信息
    if (new Date(Number(getTokenTimeout()) * 1000) < new Date()) {
      // vuex初始化时不存在UserModule，直接清除storage
      if (UserModule) {
        UserModule.Logout();
      } else {
        removeToken();
        removeTokenTimeout();
      }
    }
  }

  return localStorage.getItem("token") || "";
}

export function setToken(token: string) {
  UserModule.UpdateToken(token);
  return localStorage.setItem("token", token);
}

export function removeToken() {
  removeTokenTimeout();
  return localStorage.removeItem("token");
}

export function toLogin() {
  if (isJiHE()) {
    // window.__appDelegate.callAction(
    //   JSON.stringify({
    //     type: 301
    //   })
    // );
  } else {
    if (process.env.NODE_ENV === "production") {
      if (isWechat()) {
        window.location.href = `${process.env.VUE_APP_BASE_API}v1/user/auth/auth?platform=h5`;
      } else {
        router.push("/login");
      }
    } else {
      router.push("/login");
    }
  }
}

export function getTokenTimeout() {
  return localStorage.getItem("token_timeout") || "";
}

export function setTokenTimeout(tokenTimeout: string) {
  return localStorage.setItem("token_timeout", tokenTimeout);
}

export function removeTokenTimeout() {
  return localStorage.removeItem("token_timeout");
}

export function getPlatform() {
  return sessionStorage.getItem("platform") || "h5";
}

export function setPlatform(platform: string) {
  return sessionStorage.setItem("platform", platform);
}

export function removePlatform() {
  return sessionStorage.removeItem("platform");
}
